import { IconDefinition } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { TouchableOpacity, View, StyleSheet } from 'react-native';

import Toast, { BaseToastProps } from 'react-native-toast-message';
import MyAppText from '../components/MyAppText';
import { faCircleCheck, faCircleExclamation, faCircleXmark, faTimes } from '@fortawesome/pro-solid-svg-icons';
import { useStyles } from 'react-native-unistyles';


export default {
    sentinelxError: (props: BaseToastProps) => (
        <View style={[styles.container, { backgroundColor: '#790000' }]}>
            <View style={styles.content}>
                <FontAwesomeIcon fontSize={20} icon={faCircleXmark as IconDefinition} color='#FFFFFF' />
                <MyAppText style={styles.overflowWrap}>{props.text1}</MyAppText>
            </View>
            <TouchableOpacity onPress={() => Toast.hide()}>
                <FontAwesomeIcon fontSize={16} icon={faTimes as IconDefinition} color='#FFFFFF' />
            </TouchableOpacity>
        </View>
    ),
    sentinelxSuccess: (props: BaseToastProps) => (
        <View style={[styles.container, { backgroundColor: '#1D6228' }]}>
            <View style={styles.content}>
                <FontAwesomeIcon fontSize={20} icon={faCircleCheck as IconDefinition} color='#FFFFFF' />
                <MyAppText style={styles.overflowWrap}>{props.text1}</MyAppText>
            </View>
            <TouchableOpacity onPress={() => Toast.hide()}>
                <FontAwesomeIcon fontSize={16} icon={faTimes as IconDefinition} color='#FFFFFF' />
            </TouchableOpacity>
        </View>
    ),
    sentinelxWarning: (props: BaseToastProps) => (
        <View style={[styles.container, { backgroundColor: '#D64D00' }]}>
            <View style={styles.content}>
                <FontAwesomeIcon fontSize={20} icon={faCircleExclamation as IconDefinition} color='#FFFFFF' />
                <MyAppText style={styles.overflowWrap}>{props.text1}</MyAppText>
            </View>
            <TouchableOpacity onPress={() => Toast.hide()}>
                <FontAwesomeIcon fontSize={16} icon={faTimes as IconDefinition} color='#FFFFFF' />
            </TouchableOpacity>
        </View>
    ),
    sentinelInfo: (props: BaseToastProps) => {
        const { theme } = useStyles();
        return <View style={[styles.infoContainer, styles.infoContainerShadow, { backgroundColor: theme.colors.neutral['500'] }]}>
            <MyAppText style={[styles.infoText, { color: theme.colors.white['500'] }]}>{props.text1}</MyAppText>
        </View>;
    }
};

const styles = StyleSheet.create({
    container: {
        zIndex: 2147483646,
        minHeight: 56,
        maxWidth: 400,
        minWidth: 350,
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        paddingVertical: 10,
        paddingHorizontal: 16,
        borderRadius: 4,
        gap: 10
    },
    content: {
        columnGap: 10,
        flexDirection: 'row',
        alignItems: 'center',
        flex: 1
    },
    overflowWrap: {
        color: '#FFFFFF',
        overflow: 'visible',
        whiteSpace: 'break-spaces',
        textOverflow: 'ellipsis',
        fontWeight: '600',
        fontSize: 14
    },
    infoContainer: {
        zIndex: 999999,
        flexDirection: 'row',
        alignItems: 'center',
        padding: 16,
        borderRadius: 12,
    },
    infoContainerShadow: {
        shadowColor: '#000000',
        shadowOffset: {
            height: 4,
            width: -2
        },
        shadowOpacity: 0.15,
        shadowRadius: 4,
    },
    infoText: {
        fontSize: 14,
        fontWeight: '500',
    }
});
